import { useEffect } from 'react';
import { useAppState } from './app-state';
import { useServices } from './services-registry';
import { useSubscribeToPageNavigation } from './page-navigation';

export const useVisitorOnPageReporter = () => {
  const { serverApi, hostSdk, experiments } = useServices();
  const { appState } = useAppState();
  const { pageId, pageTitle } = useSubscribeToPageNavigation();
  const { visitorId } = appState;

  const shouldReportViaChatReporter = experiments.enabled(
    'specs.chat.ReportEventViaWidgetServer',
  );

  useEffect(() => {
    if (visitorId && pageId && pageTitle) {
      serverApi.reportVisitorOnPageEvent(
        pageId,
        visitorId,
        hostSdk.getAid(),
        pageTitle,
        shouldReportViaChatReporter,
      );
    }
  }, [pageId, pageTitle, visitorId, hostSdk, shouldReportViaChatReporter]);
};
